module.exports = __webpack_public_path__ + "media/lobby_normal7.327f6f82.mp3";